/**
 * ShadCN/ui `Skeleton` primitive (standard generated output — see
 * https://ui.shadcn.com/docs/components/skeleton).
 *
 * `apps/web`-native copy of `src/components/ui/skeleton.tsx` (root
 * `src/` tree, added for issue #170) — see `../../lib/utils.ts`'s module
 * doc-comment for why each tree owns its own copy.
 *
 * Added for "Unified API client with RTK Query for all frontend data
 * fetching" (Requirement #8 — "Implement error handling and loading
 * states using ShadCN/ui primitives ... consistently across all API
 * calls"), used by the TanStack Query hooks in `@/lib/api/apiClient`'s
 * consumers (e.g. `app/routes/account/Subscription.tsx`,
 * `app/routes/admin/Subscriptions.tsx`) while a query is loading.
 */

import * as React from 'react';

import { cn } from '@/lib/utils';

export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}
